import { render, staticRenderFns } from "./aboutComponent.vue?vue&type=template&id=0d95834d"
import script from "./aboutComponent.vue?vue&type=script&lang=js"
export * from "./aboutComponent.vue?vue&type=script&lang=js"
import style0 from "./aboutComponent.vue?vue&type=style&index=0&id=0d95834d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports